import React from "react";
import "./about.scss";
const About = () => {
  return (
    <>
      <section className="aboutmain" id="about">
        {window.innerWidth < 991 ? (
          <>
            <img
              src="/assets/aboutassets/aboutbgmbl.png"
              alt="aboutbg"
              className="aboutbg"
            />
            <img
              src="/assets/aboutassets/aboutrightimgmbl.png"
              alt="aboutrightimg"
              className="aboutrightimg"
            />
          </>
        ) : (
          <>
            <img
              src="/assets/aboutassets/aboutbg.png"
              alt="aboutbg"
              className="aboutbg"
            />
            <img
              src="/assets/aboutassets/aboutrightimg.png"
              alt="aboutrightimg"
              className="aboutrightimg"
            />
          </>
        )}
        {/* <img
          src="/assets/aboutassets/aboutbg.png"
          alt="aboutbg"
          className="aboutbg"
        />
        <img
          src="/assets/aboutassets/aboutrightimg.png"
          alt="aboutrightimg"
          className="aboutrightimg"
        /> */}
        <span className="aboutshade"></span>
        <div className="custom-container">
          <div className="aboutheadings">
            <span className="aboutspan">What Is Luckify?</span>
            <h4 className="abouthead">The End of Rigged Games</h4>
            <p className="aboutpara">
              Luckify is building a gaming ecosystem where randomness isn’t just
              claimed — it’s proven. Traditional games rely on hidden mechanics.
              We bring those mechanics on-chain using cryptography and economic
              incentives.
              <br /> <br />
              Whether it’s a loot box, lottery, or roulette — every outcome on
              Luckify is fair, auditable, and tamper-proof.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
